import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/axiosInstance';

export const fetchPrivacyPolicies = createAsyncThunk(
    'privacyPolicy/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/privacy-policy');
            return response.data.policies;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const createPrivacyPolicy = createAsyncThunk(
    'privacyPolicy/create',
    async (policyData, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post('/privacy-policy', policyData);
            return response.data.policy;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const updatePrivacyPolicy = createAsyncThunk(
    'privacyPolicy/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/privacy-policy/${id}`, data);
            return response.data.policy;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

export const deletePrivacyPolicy = createAsyncThunk(
    'privacyPolicy/delete',
    async (id, { rejectWithValue }) => {
        try {
            await axiosInstance.delete(`/privacy-policy/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

const privacyPolicySlice = createSlice({
    name: 'privacyPolicy',
    initialState: {
        policies: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPrivacyPolicies.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPrivacyPolicies.fulfilled, (state, action) => {
                state.loading = false;
                state.policies = action.payload;
            })
            .addCase(fetchPrivacyPolicies.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createPrivacyPolicy.fulfilled, (state, action) => {
                state.policies.push(action.payload);
            })
            .addCase(updatePrivacyPolicy.fulfilled, (state, action) => {
                const index = state.policies.findIndex(p => p._id === action.payload._id);
                if (index !== -1) {
                    state.policies[index] = action.payload;
                }
            })
            .addCase(deletePrivacyPolicy.fulfilled, (state, action) => {
                state.policies = state.policies.filter(p => p._id !== action.payload);
            });
    }
});

export default privacyPolicySlice.reducer;
